import * as React from 'react';

interface IProps {
    text: string;
}

class TitleComp extends React.Component<IProps, any> {
    public render() {
        const props = this.props;
        return (
            <div className="title">
                <span className="nav-back" onClick={() => this._backAction()}>
                    <img src={require('../../assets/images/icon-left.png')} />
                </span>
                <h5>{props.text}</h5>
            </div>
        )
    }
    // 返回上一页
    private _backAction() {
        window.history.back();
    }
}

export default TitleComp;


// WEBPACK FOOTER //
// ./src/components/common/title.tsx